export default {
  loading: false,
  entities: [],
}
